var url = ''
if (window.location.host === 'galaxy-qr.premiere-cinemas.com') {
  url = 'https://galaxy-api.premiere-cinemas.com'
} else {
  url = 'https://galaxy-api.premiere-cinemas.com'
}



// WEBPACK FOOTER //
// ./src/helper/constants.js